import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';
import corran1_large from '../../img/corran1_large.jpg'; 
import corran1_medium from '../../img/corran1_medium.jpg'; 
import corran1_small from '../../img/corran1_small.jpg'; 

const WalkCorranDetails = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity(""));
  }

  return (
    <div className="row">
    <div className="col-12 imagesBackgroundColour">
        <div className="generalTextBox">
          <p className="activity-back-button">
            <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
          </p>
        </div>
    </div>
    <div className="col-12 imagesBackgroundColour"> 
        <div className="generalText">
          <div className="generalTextBox">
            <h2 className="walks-section-heading">Corran</h2>
            <h3 className="walks-detail-heading"><strong>Directions</strong></h3>
            <p className="walk-text">Head along the road to Corran past Arnisdale Lodge and out of the village.  Once in Corran 
                                      visit Sheena's tea hut for refreshments.  The Ceilidh House is always worth a visit for a snapshot of local history.  There 
                                      is also a small children's play area.  Return the same way or head over the headland next to the Ceilidh House and along the beach.
            </p>      
            <h3 className="walks-detail-heading"><strong>Time</strong></h3>
            <p className="walk-text">45 mins there and back.
            </p>                                           
          </div>
        </div>
      </div>
      <div className="col-12 imagesBackgroundColour walk-image">
      <picture>
        <source srcSet={`${corran1_small} 1x,${corran1_medium} 2x`} media="(max-width: 600px)" />
        <img srcSet={`${corran1_medium} 1x,${corran1_large} 2x`}
          src={corran1_medium} alt="View of Ceilidh House" className="image"
        />
      </picture>
    </div>
    <div className="col-12 imagesBackgroundColour">
      <div className="generalText">
          <div className="generalTextBox">
            <p className="activity-back-button">
              <span className="navigate-span"><a className="navigate-button" onClick={navigateToActivity}>Back</a></span>
            </p>
          </div>
      </div>
    </div>
    </div>
  );
}

export default WalkCorranDetails
